import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort, pre } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function KGToTextTab({ onOpenTrace }) {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditKgToText);

  const columns = [
    { key: 'timestamp', header: t('traceability:columns.timestamp'), render: (r) => formatTs(r.timestamp) },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'model', header: t('traceability:columns.model') },
    { key: 'tokens_out', header: t('traceability:columns.tokensOut') },
    { key: 'duration_ms', header: t('traceability:columns.duration') },
    { key: 'output_preview', header: 'Output', render: (r) => pre(r.output_preview, 240) },
    { key: 'trace_id', header: t('traceability:columns.traceId'),
      render: (r) => <button onClick={(e) => { e.stopPropagation(); onOpenTrace(r.trace_id); }}
                             className="hover:text-accent-text">{monoShort(r.trace_id, 10)}</button> },
  ];

  return (
    <div>
      <InfoBox tabKey="kgToText" />
      <AuditFiltersBar value={filters} onChange={setFilters} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev}
                  onRowClick={(r) => onOpenTrace(r.trace_id)} />
    </div>
  );
}
